import EntityType from '@/models/Shared/EntityType';

export class InactivityReportRequest {
    entityType: EntityType = EntityType.Company;
    lookbackDays = 30;
    branchId: string | null = null;
    deskId: string | null = null;
    ownerId: string | null = null;
    activityType: number | null = null;
    categoryId: string | null = null;
    includeNever = false;
    page = 1;
    pageSize = 50;
    sortBy = 'name';
    sortDir = 'asc';
}

export interface InactivityReportRow {
    id: string;
    name: string;
    secondaryLabel?: string;
    lastActivityAt: string | null;
    lastActivityType?: number;
    lastActivityOwner?: string;
    daysSinceActivity?: number;
}

export interface InactivityReportResponse {
    entityType: EntityType;
    lookbackDays: number;
    generatedAt: string;
    totalCount: number;
    page: number;
    pageSize: number;
    items: InactivityReportRow[];
}
